import React from 'react';
import PropTypes from 'prop-types';

import HtmlElement from '../HtmlElement';

const defaultProps = {
  children: null,
};

const propTypes = {
  children: PropTypes.node,
};

const Container = ({
  children,
  ...props
}) => (
  <HtmlElement
    tagName="div"
    {...props}
  >
    {children}
  </HtmlElement>
);

Container.defaultProps = defaultProps;
Container.propTypes = propTypes;

export default Container;
